import { Icon, Text, HStack, VStack } from '@genial/components';
import { Spacing, Color, BoxRadius, Typography } from '@genial/design-tokens';
import { Box, Pressable } from 'native-base';
import React from 'react';
import { useRecoilState } from 'recoil';

import { batchActionState } from '../../../../../../store/ProducManagement/atom';

interface HeaderSectionProps {
  goBack: () => void;
  direction: 'bottom' | 'right';
}
export const HeaderSection: React.FC<HeaderSectionProps> = ({ goBack, direction }) => {
  const directionIsBottom = direction === 'bottom';
  const [, setBatchActionItems] = useRecoilState(batchActionState);

  const handleGoBack = () => {
    setBatchActionItems(null);
    goBack();
  };

  return (
    <VStack
      w="full"
      py={Spacing['inline.xxxs']}
      borderTopRadius={{ base: Spacing['inline.xxxs'], lg: 0 }}
      backgroundColor={Color['neutral.white']}
      space={Spacing['inline.xxxs']}>
      {directionIsBottom && (
        <Box
          w="55px"
          alignSelf="center"
          background={'neutral.lightest'}
          borderRadius={BoxRadius.sm}
          h={1}
        />
      )}
      <HStack
        borderTopRadius={{ base: BoxRadius.md, lg: 0 }}
        bg="neutral.white"
        px={Spacing['inline.xxxs']}
        space={Spacing['stack.quarck']}
        alignItems="center"
        justifyContent="space-between">
        <HStack alignItems="center" space={Spacing['inline.nano']}>
          <Pressable testID={'button-close-filter-screen'} onPress={handleGoBack}>
            <Icon
              testID={'icon-close-filter-screen'}
              name="ArrowLeft"
              size="xs"
              variant="default"
              {...(direction !== 'bottom' && { borderWidth: 0.05 })}
              backgroundColor="transparent"
              color={Color['brand.primary.principal']}
              borderColor={Color['brand.primary.principal']}
            />
          </Pressable>
          <Text
            variant="bold"
            fontSize={Typography['fontsize.lg']}
            lineHeight="distant"
            color="neutral.black">
            Adicionar bloqueio
          </Text>
        </HStack>
        <Pressable testID={'button-close-filter-screen'} onPress={handleGoBack}>
          <Icon
            testID={'icon-close-filter-screen'}
            name="Close"
            size="xs"
            variant="rounded"
            {...(direction !== 'bottom' && { borderWidth: 0.05 })}
            backgroundColor="transparent"
            color={Color['brand.primary.principal']}
            borderColor={Color['brand.primary.principal']}
          />
        </Pressable>
      </HStack>
    </VStack>
  );
};
